module.exports = __webpack_public_path__ + "site/img/plus_black.27c78da6.svg";